module.exports = __webpack_public_path__ + "img/character04.d6aca5bf.png";